import React from "react";
import { ReactElement } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ExternalAccessPasswordChangePage from "app/modules/shared/externalAccess/password/ExternalAccessPasswordChangePage";
import { AuthLayout } from "app/modules/auth/AuthLayout";

const ExternalAccessComponents: { [name: string]: ReactElement } = {
  passwordchange: <ExternalAccessPasswordChangePage />,
};

type ExternalAccessRoutesProps = {
  allowedRoute: string;
};

const ExternalAccessRoutes: React.FC<ExternalAccessRoutesProps> = ({ allowedRoute }) => {
  const externalAccessComponent = ExternalAccessComponents[allowedRoute];
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route
          path={allowedRoute}
          element={externalAccessComponent ? externalAccessComponent : <Navigate to="/error/404" />}
        />
      </Route>
    </Routes>
  );
};

export default ExternalAccessRoutes;
